import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { ViewStepVM } from 'civil-status/view-models/step-form';

interface AnnotationsAccordionProps {
  formContext: FormikProps<ViewStepVM>;
}

const AnnotationsAccordionComponent = ({
  formContext,
}: AnnotationsAccordionProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      {(formContext.values?.annotations || [])?.length > 0 ? (
        <Accordion
          expanded={open}
          onChange={() => {
            setOpen(!open);
          }}
        >
          <AccordionSummary
            aria-controls="accordion-annotations-act-content"
            id="accordion-annotations-act-header"
            expandIcon={<ExpandMore />}
          >
            <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              Annotazioni contestuali
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {(formContext.values?.annotations || [])?.map((item, index) => {
                return (
                  <Fragment key={`${item.type}-${index}`}>
                    <Grid item xs={12} md={3}>
                      Tipo annotazione:
                    </Grid>
                    <Grid item xs={12} md={9}>
                      <span style={{ fontWeight: 'bold' }}>{item.type || ''}</span>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      Testo annotazione:
                    </Grid>
                    <Grid item xs={12} md={9}>
                      {item.text || ''}
                    </Grid>
                  </Fragment>
                );
              })}
            </Grid>
          </AccordionDetails>
        </Accordion>
      ) : undefined}
    </Fragment>
  );
};

AnnotationsAccordionComponent.displayName = 'Annotations Accordion Component';

const AnnotationsAccordion = memo(AnnotationsAccordionComponent);

export default AnnotationsAccordion;
